import { clientTrustSliderData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function ClientTrustSlider() {
  const items = clientTrustSliderData.items;
  // Double the items for seamless infinite scroll
  const doubledItems = [...items, ...items];

  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="container-astro mb-8 md:mb-10">
        <AnimatedSection>
          <div className="text-center">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-foreground-950 mb-2 font-heading tracking-tight">
              {clientTrustSliderData.heading}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              Helping businesses across industries build, scale and transform their digital presence.
            </p>
          </div>
        </AnimatedSection>
      </div>

      {/* Auto-scrolling slider */}
      <div className="relative w-full overflow-hidden">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-background-50 to-transparent z-10 pointer-events-none" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-background-50 to-transparent z-10 pointer-events-none" />

        <div
          className="flex items-center gap-8 md:gap-12 animate-scroll-x hover:[animation-play-state:paused]"
          style={{
            width: "max-content",
          }}
        >
          {doubledItems.map((item, i) => (
            <div
              key={`${item.name}-${i}`}
              className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-300/30 transition-all duration-300 shrink-0"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-gradient-to-br from-[#2563EB]/10 to-[#7C3AED]/10 text-[#2563EB]">
                <i className={`${item.icon} text-sm`} />
              </span>
              <span className="text-sm font-semibold text-foreground-700 font-heading whitespace-nowrap">
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* CSS for auto-scroll animation */}
      <style>{`
        @keyframes scroll-x {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll-x {
          animation: scroll-x 30s linear infinite;
        }
      `}</style>
    </section>
  );
}